import { FC } from 'react';

import { TextBase, TextBaseProps } from './TextBase';

type TextPropsWithoutStylingOptions = Omit<TextBaseProps, 'className' | 'style'>;

export const Text: FC<TextPropsWithoutStylingOptions> = (props) => <TextBase {...props} />;

export { type TTextBaseSize } from './TextBase';
